<template>
  <div class="page-container">
    <div v-if="!isComponent && !isFlowComponent">
      <div class="page_title">
        <div class="page_title_desc">停车场管理</div>
      </div>
      <el-divider></el-divider>
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
          <el-select
            v-model="filterForm.parkNo"
            clearable
            filterable
            placeholder="请选择停车场"
          >
            <el-option
              v-for="item in allParkList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="filterForm.coalMineNo"
            clearable
            filterable
            placeholder="请选择煤矿"
          >
            <el-option
              v-for="item in allCoalmineList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="filterForm.userName"
            clearable
            filterable
            placeholder="请选择管理员"
          >
            <el-option
              v-for="item in adminList"
              :key="item.code"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-plus"
            label="新增"
            perms="31000"
            @click="handleAdd"
            type="primary"
          />
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        :data="parkList"
        stripe
        size="mini"
        style="width: 100%"
        row-key="parkNo"
      >
        <el-table-column
          type="index"
          align="center"
          width="50"
          fixed
          label="序号"
        >
        </el-table-column>
        <el-table-column prop="parkName" align="center" label="停车场名称">
        </el-table-column>
        <el-table-column prop="coalMineName" align="center" label="绑定煤矿">
        </el-table-column>
        <el-table-column prop="userName" align="center" label="账号">
        </el-table-column>
        <el-table-column prop="contactPhone" align="center" label="手机号">
        </el-table-column>
        <el-table-column prop="totalAmount" align="center" label="余额（元）">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="400">
          <template slot-scope="scope">
            <kt-button
              icon="fa fa-edit"
              label="编辑"
              perms="31002"
              @click="handleEdit(scope.row)"
            />
            <kt-button
              label="删除"
              perms="31001"
              @click="handleDel(scope.row)"
              icon="fa fa-remove"
              type="danger"
            />
            <kt-button
              label="详情"
              perms="-1"
              icon="fa fa-list"
              @click="checkComponent(scope.row)"
              type="primary"
            />
            <kt-button
              label="车辆出入流水"
              perms="-1"
              icon="el-icon-tickets"
              @click="handleShowFlowComponent(scope.row)"
              type="primary"
            />
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float: right"
        >
        </el-pagination>
      </div>
    </div>
    <!--查看详情-->
    <component 
      :is="isComponent"
      @backFun="backFun"
      :parkDetailParams="parkDetailParams">
    </component>
    <!--出场流水-->
    <component 
      :is="isFlowComponent"
      @flowBackFun="flowBackFun"
      :flowDetailParams="flowDetailParams">
    </component>
    <!--新增 修改弹窗-->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleClose"
    >
      <el-form
        :model="parkForm"
        status-icon
        :rules="rules"
        ref="parkForm"
        label-width="120px"
        class="demo-parkForm"
      >
        <el-row>
          <el-col :span="21">
            <el-form-item label="停车场名称" prop="parkName">
              <el-input
                type="text"
                v-model="parkForm.parkName"
                clearable
                show-word-limit
                placeholder="请输入20个字以内的停车场名称"
                maxlength="20"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="21">
            <el-form-item label="绑定煤矿" prop="coalMineNo">
              <el-select
                v-model="parkForm.coalMineNo"
                clearable
                filterable
                placeholder="请选择煤矿"
              >
                <el-option
                  v-for="item in enableCoalmineList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="21">
            <el-form-item label="账号" prop="userName">
              <el-input
                placeholder="请输入8~16个英文或数字的账号"
                type="text"
                clearable
                v-model="parkForm.userName"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="21">
            <el-form-item label="手机号" prop="contactPhone">
              <el-input
                placeholder="请输入手机号"
                type="text"
                clearable
                v-model="parkForm.contactPhone"
                @keyup.native="onlyNumber"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";
import { isMobile, isNumOrLetter } from "@/utils/validate";

export default {
  components: {
    KtButton,
  },
  data() {
    const checkMobile = (rule, value, callback) => {
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号码"));
      }
    };
    const checkUserName = (rule, value, callback) => {
      if (isNumOrLetter(value)) {
        callback();
      } else {
        callback(new Error("请输入8~16个英文或数字的账号"));
      }
    };
    return {
      isComponent: "", // 详情组件
      isFlowComponent: "", // 流水组件
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      allParkList: [],
      parkList: [],
      allCoalmineList: [],
      enableCoalmineList: [],
      adminList: [],
      filterForm: {
        parkNo: "",
        coalMineNo: "",
        userName: "",
      },
      dialogVisible: false,
      title: "",
      parkForm: {
        parkName: "",
        coalMineNo: "",
        userName: "",
        contactPhone: "",
      },
      rules: {
        parkName: [
          { required: true, message: "请输入停车场名称", trigger: "blur" },
        ],
        coalMineNo: [
          { required: true, message: "请选择煤矿", trigger: "change" },
        ],
        userName: [
          {
            required: true,
            message: "请输入8~16个英文或数字的账号",
            trigger: "blur",
          },
          { validator: checkUserName, trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
      },
      parkDetailParams: {},
      flowDetailParams: {}
    };
  },
  mounted() {
    this.getParkList();
    this.getSimpleParkList();
    this.getAllCoalmineList();
    this.getEnableList();
    this.getParkAdminList();
  },
  methods: {
    async getParkList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params[key] = val;
        }
      }
      let res = await this.$api.park.mGetParkList(params);
      const data = res.data;
      this.totalSize = data.totalSize || 0;
      if (data && data.dtoList && data.dtoList.length > 0) {
        this.parkList = data.dtoList;
      } else {
        this.parkList = [];
      }
      this.loading = false;
    },
    // 停车场名称--下拉
    getSimpleParkList() {
      this.$api.finance.getSimpleParkList().then((res) => {
        if (res.data && res.data.length > 0) {
          this.allParkList = res.data;
        } else {
          this.allParkList = [];
        }
      });
    },
    // 获取所有煤矿
    getAllCoalmineList() {
      this.$api.finance.getAllCoalmineList().then((res) => {
        if (res.data && res.data.length > 0) {
          this.allCoalmineList = res.data;
        } else {
          this.allCoalmineList = [];
        }
      });
    },
    // 获取所有煤矿
    getEnableList() {
      this.$api.park.getEnableList().then((res) => {
        if (res.data && res.data.length > 0) {
          this.enableCoalmineList = res.data;
        } else {
          this.enableCoalmineList = [];
        }
      });
    },
    // 管理员名称--下拉
    getParkAdminList() {
      this.$api.park.getParkAdminList().then((res) => {
        if (res.data && res.data.length > 0) {
          this.adminList = res.data;
        } else {
          this.adminList = [];
        }
      });
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getParkList();
    },
    handleSearch() {
      this.pageNo = 1;
      this.getParkList();
    },
    // 重置
    handleReset() {
      this.filterForm = {
        parkNo: "",
        coalMineNo: "",
        userName: "",
      };
      this.handleSearch();
    },
    // 点击新增按钮
    handleAdd() {
      this.title = "新增停车场";
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.title = "编辑停车场";
      this.parkForm = { ...row };
      this.dialogVisible = true;
    },
    handleDel(row) {
      this.$confirm("是否删除该停车场", "提示", {
        type: "warning",
      }).then(() => {
        const params = { parkNo: row.parkNo };
        this.$api.park.deletePark(params).then((res) => {
          this.$message({ message: "操作成功", type: "success" });
          this.getParkList();
          this.getSimpleParkList();
          this.getParkAdminList();
        });
      });
    },
    // 新增 修改弹窗确认按钮
    submitForm() {
      this.$refs["parkForm"].validate((valid) => {
        if (valid) {
          const params = {
            ...this.parkForm,
          };
          params["coalMineName"] = this.allCoalmineList.find(
            (item) => item.code == this.parkForm.coalMineNo
          ).name;
          const mParkApi = !this.parkForm.parkNo
            ? this.$api.park.addPark(params)
            : this.$api.park.updatePark(params);
          mParkApi.then((res) => {
            this.$message({
              message: "操作成功!",
              type: "success",
            });
            this.dialogVisible = false;
            this.getParkList();
            this.getSimpleParkList();
            this.getParkAdminList();
          });
        }
      });
    },
    handleClose() {
      if (this.$refs.parkForm) {
        this.parkForm = {};
        this.$refs["parkForm"].resetFields();
      }
    },
    onlyNumber() {
      this.parkForm.contactPhone = this.parkForm.contactPhone.replace(
        /[^\d]/g,
        ""
      );
    },
    //查看详情
    checkComponent(row) {
      this.parkDetailParams = {
        coalMineNo: row.coalMineNo,
        parkNo: row.parkNo
      }
      this.isComponent
        ? (this.isComponent = "")
        : (this.isComponent = () => import("./ParDetail"));
    },
    // 详情返回
    backFun(val){
      this.isComponent = val
    },
    // 查看流水
    handleShowFlowComponent(row){
      this.flowDetailParams = {
        coalMineNo: row.coalMineNo,
        parkNo: row.parkNo
      }
      this.isFlowComponent
        ? (this.isFlowComponent = "")
        : (this.isFlowComponent = () => import("./CarInOutRecord"));
    },
    // 流水返回
    flowBackFun(val){
      this.isFlowComponent = val
    }
  },
};
</script>
<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
.page-container{
  height: 100%;
}
</style>
